import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 1em;

  p,
  strong {
    font-family: 'Inter', sans-serif;
  }
`;

export const Description = styled.p`
  color: #000;
  font-size: 1em;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5em;

  strong {
    font-weight: bold;
  }

  @media (max-width: 375px) {
  }
`;

export const ContentVideo = styled.div`
  display: grid;
  place-items: center;

  gap: 1em;

  p {
    font-weight: 500;
    font-size: 1.3em;
    color: #0015c1;
  }
`;
